<template>
  <v-dialog
    v-model="messageModal"
    max-width="600"
  >
    <v-card>
      <v-card-title class="subheading">Сообщение</v-card-title>
      <v-card-text>
        <p>{{message}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="isPrompt">
          <v-btn
            color="accent"
            flat="flat"
            @click="confirm"
          >
            Да
          </v-btn>
          <v-btn
            color="secondary"
            flat="flat"
            @click="cancel"
          >
            Нет
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            color="accent"
            flat="flat"
            @click="messageModal = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MessageModal',
  data () {
    return {
      messageModal: false,
      message: '',
      isPrompt: false
    }
  },
  methods: {
    open (message, isPrompt = false) {
      this.message = message
      this.isPrompt = isPrompt
      this.messageModal = true
    },
    close () {
      this.messageModal = false
    },
    confirm () {
      this.messageModal = false
      this.$emit('confirm')
    },
    cancel () {
      this.messageModal = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
